const state = {
    photos: [],
    maxPhotos: 10,
    specialTos: 0,
}

const getters = {
    photos: state => state.photos,
    maxPhotos: state => state.maxPhotos,
    specialTos: state => state.specialTos
}

const actions = {
    addPhoto ({ commit }, photo) {
        console.log(photo)
        commit('addPhoto', photo.photo)
        commit('specialTos', photo.tos)
    },

    removePhoto({ commit }, photo) {
        console.log(photo)
        commit('removePhoto', photo.photo)
        commit('specialTos', photo.tos)
    },
}

const mutations = {
    addPhoto (state, photo) {
        if (state.photos.length < state.maxPhotos){
            state.photos.push(photo)
        }
        return state.photos.length < state.maxPhotos
    },

    removePhoto (state, photo) {
        let photos = state.photos.filter((value) => {
            return value != photo
        })
        state.photos = photos
    },

    specialTos (state, tos) {
        state.specialTos = state.specialTos + tos
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
